import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/message/importer/messageImporterActions'

export default importerReducers(actions)
